import { Button } from 'primereact/button';
import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import { LaudoService } from '../../../../viewer/src/service/LaudoService';

const Laudo = (props) => {

  const { studyUid, positionMenu } = props;

  //Adicionar tab 'Laudo'
  const [infoLaudo, setInfoLaudo] = useState({
    Texto: "",
    Anexo: [],
    Obs: "",
    Load: false
  });

  const listaAnexos = (data) => {
    if (data.Anexos.length) {
      const boxAnexos = [];
      data.Anexos.map(anexo => {
        boxAnexos.push(<div style={{ borderBottom: 'solid 1px #041c4a', marginTop: '10px', padding: '5px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'auto 70px' }}>
            <div style={{ textAlign: 'left' }}>{icone(anexo.TipoArquivo)}{anexo.Nome.replace(anexo.TipoArquivo, '')}</div>
            <div>{spanTipoAnexo(anexo.TipoAnexo)}</div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', marginTop: '5px', marginLeft: '5px' }}>
            <div><Button style={{ fontSize: '12px' }} label='Visualizar' icon='pi pi-search' className='p-buttom-sm p-button-text' onClick={() => openAnexo(anexo.Id)} /></div>
            <div><Button style={{ fontSize: '12px' }} label='Download' onClick={() => downloadAnexo(anexo)} icon='pi pi-download' className='p-buttom-sm p-button-text' /></div>
          </div>
        </div>);
      });
      return boxAnexos;
    }
  }

  const obterDadosLaudo = () => {
    const laudoService = new LaudoService();
    laudoService.GetLaudo(studyUid)
      .then(resp => {
        setInfoLaudo({
          Texto: resp.LaudoTexto,
          Anexo: listaAnexos(resp.Anexos),
          Obs: resp.Observacoes,
          Load: true
        })
      })
      .catch(error => {
        console.log(error);
        setInfoLaudo({
          Texto: "Não foi possível obter texto do lado.",
          Anexo: [],
          Obs: "",
          Load: true
        })
      });
  }


  useEffect(() => {
    if (!infoLaudo.Load)
      obterDadosLaudo();
  }, [infoLaudo.Load])

  const spanTipoAnexo = (tipoAnexo) => {
    const st = { padding: '5px', borderRadius: '5px', fontSize: '10px', width: '70px', textAlign: 'center', fontWeight: 'bold', display: 'inline-block' };
    switch (tipoAnexo) {
      case 0:
        return <span style={{ ...st, background: 'green' }}>Normal</span>
      case 1:
        return <span style={{ ...st, background: 'orange' }}>Diagnóstico</span>
      case 2:
        return <span style={{ ...st, background: 'blue' }}>Anamnese</span>
      case 3:
        return <span style={{ ...st, background: 'indianred' }}>Ped. Médico</span>
    }
  }
  const icone = (icon) => {

    icon = icon.toLowerCase();

    if (icon === '.pdf')
      return <i className='pi pi-file-pdf' style={{ color: 'indianred', marginRight: '5px' }}></i>;

    if (icon === '.doc' || icon === '.docx')
      return <i className='pi pi-file' style={{ color: 'blue', marginRight: '5px' }}></i>;

    if (icon === '.xls' || icon === '.xlsx' || icon === '.csv')
      return <i className='pi pi-file-excel' style={{ color: 'green', marginRight: '5px' }}></i>;

    if (icon === '.txt')
      return <i className='pi pi-file' style={{ marginRight: '5px' }}></i>;

    if (icon === '.zip' || icon === '.rar')
      return <i className='pi pi-clone' style={{ color: 'orange', marginRight: '5px' }}></i>;
  }

  const downloadAnexo = (anexo) => {
    const downloadUrl = `${window.config.servico}/api/Anexo/GetAnexo/${anexo.Id}`;
    const postData = new FormData();
    const xhr = new XMLHttpRequest();
    xhr.open('GET', downloadUrl, true);
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
      const blob = xhr.response;
      const fileName = `${anexo.Nome}`;
      const tempEl = document.createElement("a");
      document.body.appendChild(tempEl);
      const url = window.URL.createObjectURL(blob);
      tempEl.href = url;
      tempEl.download = fileName;
      tempEl.click();
      window.URL.revokeObjectURL(url);
      document.removeChild(tempEl);
    }.bind(this)
    xhr.send(postData);
  }

  const openAnexo = (idAnexo) => {
    window.open(`${window.config.servico}/Api/Anexo/GetAnexo/${idAnexo}`);
  }

  //Auto Height
  const [windowHeight, setWindowHeight] = useState(window.innerHeight - (positionMenu === 1 ? 240 : 310));

  useEffect(() => {
    if (positionMenu)
      setWindowHeight(window.innerHeight - (positionMenu === 1 ? 240 : 310));
  }, [positionMenu])

  window.onresize = () => {
    setWindowHeight(window.innerHeight - (positionMenu === 1 ? 240 : 310));
  }
  //Fim Auto Height

  return (<div>
    <TabView style={{ marginTop: '10px' }}>
      <TabPanel header="Laudo">
        <div className="m-3" style={{ overflow: 'auto', height: `${windowHeight}px` }}>
          {infoLaudo.Texto}
        </div>
      </TabPanel>
      <TabPanel header="Anexos">
        <div className="m-1" style={{ overflow: 'auto', height: `${(windowHeight + 15)}px` }}>
          {infoLaudo.Anexo}
        </div>
      </TabPanel>
      <TabPanel header="Obs">
        <div className="m-3" style={{ overflow: 'auto', height: `${windowHeight}px` }}>
          {infoLaudo.Obs}
        </div>
      </TabPanel>
    </TabView>
  </div>);
}

export default Laudo;
